import axios from 'axios'
import { setupInterceptors } from './interceptors'

export { registerAuthStore, registerUiStore } from './interceptors'

// ---------------------------------------------------------------------------
// SECURITY: baseURL MUST point to /api/admin — NEVER /api/v1
// The admin panel has ZERO access to user-facing API endpoints.
// ---------------------------------------------------------------------------

const baseURL = import.meta.env.VITE_API_BASE_URL ?? '/api/admin'

// Runtime guard: reject any baseURL containing /api/v1
if (baseURL.includes('/api/v1')) {
  throw new Error(
    'SECURITY VIOLATION: Admin HTTP client baseURL must NEVER contain /api/v1. ' +
    'Check VITE_API_BASE_URL environment variable.',
  )
}

const apiClient = axios.create({
  baseURL,
  timeout: 30_000,
  withCredentials: true, // required for CORS with credentials (cookies, auth headers)
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

setupInterceptors(apiClient)

export default apiClient
